import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAlignJustify,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleDown,
  faAngleRight,
  faAngleUp,
  faArrowCircleUp,
  faArrowCircleDown,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowsAltV,
  faArrowUp,
  faBasketballBall,
  faBed,
  faBell,
  faCalendar,
  faCalendarAlt,
  faCaretDown,
  faCaretRight,
  faCaretUp,
  faChartBar,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faClipboardList,
  faClock,
  faComments,
  faEdit,
  faEllipsisH,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFilter,
  faFont,
  faGraduationCap,
  faHeartbeat,
  faHistory,
  faIdCard,
  faInfoCircle,
  faLanguage,
  faListUl,
  faLock,
  faPaperPlane,
  faPencilAlt,
  faPills,
  faPlayCircle,
  faPlus,
  faMinus,
  faPowerOff,
  faQuestion,
  faRandom,
  faScroll,
  faSearch,
  faSortAmountDown,
  faSortAmountUp,
  faSortDown,
  faSpinner,
  faStopCircle,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  faUser,
  faWindowRestore,
  faMobileAlt,
  faDollarSign,
  faFileInvoiceDollar,
  faSyncAlt,
  faCopy,
  faUsers,
  faShieldAlt,
  faTasks,
  faProjectDiagram,
  faUpload,
  faFile,
  faFileExcel,
  faFilePdf,
  faFileDownload,
  faUnlock,
  faSquare,
  faVolumeUp,
  faVolumeMute,
  faPhoneSlash,
  faPhone,
  faVideo,
  faVideoSlash,
  faMicrophone,
  faMicrophoneSlash,
  faPrint,
  faBan,
  faExclamation,
  faChevronLeft,
  faChevronRight,
  faFolder,
  faHandHoldingHeart,
  faHandHoldingMedical,
  faArchive,
  faLaptopMedical,
  faSync,
  faClinicMedical,
  faBuilding,
  faLink,
  faQuestionCircle,
  faKey,
  faLockOpen,
  faTabletAlt,
  faSms,
  faPhoneVolume,
  faPlusCircle,
  faFileArchive,
  faDownload,
  faStethoscope,
  faImage,
  faReply,
  faWandMagicSparkles
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faIdCard,
  faLock,
  faEnvelope,
  faExclamationCircle,
  faSearch,
  faPlus,
  faMinus,
  faComments,
  faBell,
  faSortDown,
  faTimes,
  faArrowLeft,
  faChartBar,
  faBed,
  faPills,
  faCalendarAlt,
  faHeartbeat,
  faGraduationCap,
  faClipboardList,
  faEdit,
  faClock,
  faSpinner,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faCheck,
  faTrash,
  faSortAmountDown,
  faSortAmountUp,
  faUser,
  faPencilAlt,
  faEllipsisH,
  faArrowCircleUp,
  faArrowCircleDown,
  faCalendar,
  faListUl,
  faInfoCircle,
  faExclamationTriangle,
  faTrashAlt,
  faCheckCircle,
  faTimesCircle,
  faWindowRestore,
  faCheckDouble,
  faArrowDown,
  faArrowRight,
  faPaperPlane,
  faEyeSlash,
  faEye,
  faQuestion,
  faRandom,
  faCaretUp,
  faCaretDown,
  faAngleUp,
  faAngleDown,
  faAngleRight,
  faArrowsAltV,
  faAlignJustify,
  faFont,
  faScroll,
  faFilter,
  faLanguage,
  faBasketballBall,
  faArrowUp,
  faPowerOff,
  faCaretRight,
  faPlayCircle,
  faStopCircle,
  faHistory,
  faMobileAlt,
  faDollarSign,
  faFile,
  faFileInvoiceDollar,
  faSyncAlt,
  faCopy,
  faUsers,
  faShieldAlt,
  faTasks,
  faProjectDiagram,
  faUpload,
  faFileExcel,
  faFilePdf,
  faFileDownload,
  faUnlock,
  faSquare,
  faVolumeUp,
  faVolumeMute,
  faPhoneSlash,
  faPhone,
  faVideo,
  faVideoSlash,
  faMicrophone,
  faMicrophoneSlash,
  faPrint,
  faBan,
  faExclamation,
  faChevronLeft,
  faChevronRight,
  faFolder,
  faHandHoldingHeart,
  faHandHoldingMedical,
  faLaptopMedical,
  faSync,
  faClinicMedical,
  faBuilding,
  faLink,
  faQuestionCircle,
  faKey,
  faLockOpen,
  faTabletAlt,
  faSms,
  faPhoneVolume,
  faPlusCircle,
  faFileArchive,
  faDownload,
  faStethoscope,
  faImage,
  faReply,
  faWandMagicSparkles
)
